import Vue from "vue";
import Router from "vue-router";

import main from "./main_routes";
import errorRoutes from "./error_routes";
import service_admin_routes from "./service_admin_routes";
import rating_routes from "./rating_routes";
import payment_routes from "./payment_routes";
import my_winners_routes from "./my_winners_routes";
import my_winners_register_routes from "./my_winners_register_routes";
import my_organization_routes from "./my_organization_routes";
import calc_settings_routes from "./calc_settings_routes";
import calc_routes from "./calc_routes";
import calc_register_routes from "./calc_register_routes";
import calc_register_manager_routes from "./calc_register_manager_routes";
import winners_manager_routes from "./winners_manager_routes";
import winners_chelkunov_routes from "./winners_chelkunov_routes";
import register_bg_routes from "./register_bg_routes";
import client_documents_routes from "./client_documents_routes";
import { bank_calc_settings } from "./bank_calc_settings_routes";
import { agregator_calc_settings } from "./agregator_calc_settings_routes";

Vue.use(Router);

const uniqMenu = (menu) => {
  let result = new Array();
  const menuIds = new Array();
  for (const item of menu) {
    if (!menuIds.includes(item.id)) {
      result.push(item);
      menuIds.push(item.id);
    } else {
      result = result.filter((row) => row.id !== item.id);
      result.push(item);
      menuIds.push(item.id);
    }
  }
  return result;
};

const generateRoutes = (obj) => {
  const { routes, menu } = obj;
  const newRoutes = Array.from(new Set(routes));
  const newmenu = Array.from(new Set(menu)).sort((a, b) => a.id - b.id);

  return new Router({
    mode: "history",
    routes: newRoutes,
    menu: uniqMenu(newmenu),
  });
};

export default (role) => {
  const banned = {
    routes: [...main.routes, ...errorRoutes],
    menu: [...main.menu],
  };
  const users = {
    routes: [
      ...banned.routes,
      ...calc_routes.routes,
      ...calc_register_routes.routes,
      ...my_winners_routes.routes,
      ...payment_routes.routes,
      ...rating_routes.routes,
    ],
    menu: [
      ...banned.menu,
      ...calc_routes.menu,
      ...calc_register_routes.menu,
      ...my_winners_routes.menu,
      ...payment_routes.menu,
      ...rating_routes.menu,
    ],
  };
  const usersService = {
    routes: [
      ...register_bg_routes.routes,
      ...users.routes,
      ...my_winners_register_routes.routes,
    ],
    menu: [
      ...register_bg_routes.menu,
      ...users.menu,
      ...my_winners_register_routes.menu,
    ],
  };
  const usersTest = {
    routes: [
      ...users.routes,
      ...my_winners_routes.routes,
      ...my_winners_register_routes.routes,
    ],
    menu: [
      ...users.menu,
      ...my_winners_routes.menu,
      ...my_winners_register_routes.menu,
    ],
  };
  const manager = {
    routes: [
      ...banned.routes,
      ...calc_routes.routes,
      ...winners_manager_routes.routes,
      ...payment_routes.routes,
      ...rating_routes.routes,
      ...calc_register_manager_routes.routes,
      ...my_organization_routes.routes,
    ],
    menu: [
      ...banned.menu,
      ...calc_routes.menu,
      ...winners_manager_routes.menu,
      ...payment_routes.menu,
      ...rating_routes.menu,
      ...calc_register_manager_routes.menu,
      ...my_organization_routes.menu,
    ],
  };
  const managerService = {
    routes: [
      ...register_bg_routes.routes,
      ...manager.routes,
      ...my_winners_register_routes.routes,
      ...client_documents_routes.routes,
    ],
    menu: [
      ...register_bg_routes.menu,
      ...manager.menu,
      ...my_winners_register_routes.menu,
      ...client_documents_routes.menu,
    ],
  };
  const managerTest = {
    routes: [
      ...banned.routes,
      ...calc_routes.routes,
      ...payment_routes.routes,
      ...rating_routes.routes,
      ...calc_register_manager_routes.routes,
      ...my_organization_routes.routes,
      ...winners_manager_routes.routes,
      ...my_winners_register_routes.routes,
    ],
    menu: [
      ...banned.menu,
      ...calc_routes.menu,
      ...payment_routes.menu,
      ...rating_routes.menu,
      ...calc_register_manager_routes.menu,
      ...my_organization_routes.menu,
      ...winners_manager_routes.menu,
      ...my_winners_register_routes.menu,
    ],
  };

  const admin = {
    routes: [...manager.routes],
    menu: [...manager.menu],
  };
  const adminChelkunov = {
    routes: [
      ...users.routes,
      ...my_organization_routes.routes,
      ...winners_chelkunov_routes.routes,
    ],
    menu: [
      ...users.menu,
      ...my_organization_routes.menu,
      ...winners_chelkunov_routes.menu,
    ],
  };
  const adminChelkunovTest = {
    routes: [
      ...usersTest.routes,
      ...my_organization_routes.routes,
      ...winners_chelkunov_routes.routes,
    ],
    menu: [
      ...usersTest.menu,
      ...my_organization_routes.menu,
      ...winners_chelkunov_routes.menu,
    ],
  };

  const adminTest = {
    routes: [...managerTest.routes],
    menu: [...managerTest.menu],
  };

  const bankir = {
    routes: [...manager.routes, ...calc_settings_routes.routes],
    menu: [...manager.menu, ...calc_settings_routes.menu],
  };

  const adminService = {
    routes: [
      ...bankir.routes,
      ...register_bg_routes.routes,
      ...adminTest.routes,
      // ...my_winners_routes.routes,
      ...winners_manager_routes.routes,
      ...service_admin_routes.routes,
      ...client_documents_routes.routes,
    ],
    menu: [
      ...bankir.menu,
      ...register_bg_routes.menu,
      ...adminTest.menu,
      // ...my_winners_routes.menu,
      ...winners_manager_routes.menu,
      ...service_admin_routes.menu,
      ...client_documents_routes.menu,
    ],
  };

  const demo = {
    routes: [
      ...banned.routes,
      ...calc_routes.routes,
      ...calc_register_routes.routes,
      ...rating_routes.routes,
      ...my_winners_routes.routes,
    ],
    menu: [
      ...banned.menu,
      ...calc_routes.menu,
      ...calc_register_routes.menu,
      ...rating_routes.menu,
      ...my_winners_routes.menu,
    ],
  };

  const winners = {
    routes: [
      ...banned.routes,
      ...calc_routes.routes,
      ...calc_register_routes.routes,
      ...my_winners_routes.routes,
    ],
    menu: [
      ...banned.menu,
      ...calc_routes.menu,
      ...calc_register_routes.menu,
      ...my_winners_routes.menu,
    ],
  };

  const rating = {
    routes: [
      ...banned.routes,
      ...calc_routes.routes,
      ...calc_register_routes.routes,
      ...rating_routes.routes,
      // ...winners_chelkunov_routes.routes
    ],
    menu: [
      ...banned.menu,
      ...calc_routes.menu,
      ...calc_register_routes.menu,
      ...rating_routes.menu,
      // ...winners_chelkunov_routes.menu
    ],
  };

  const calcAndRaiting = {
    routes: [...rating.routes],
    menu: [...rating.menu],
  };

  const ratingWinners = {
    routes: [...rating.routes, ...my_winners_routes.routes],
    menu: [...rating.menu, ...my_winners_routes.menu],
  };

  const calcRatingWinners = {
    routes: [...ratingWinners.routes],
    menu: [...ratingWinners.menu],
  };

  const Bank = {
    routes: [
      ...banned.routes,
      ...calc_routes.routes,
      ...calc_register_routes.routes,
      ...rating_routes.routes,
      ...bank_calc_settings.routes,
    ],
    menu: [
      ...banned.menu,
      ...calc_routes.menu,
      ...calc_register_routes.menu,
      ...rating_routes.menu,
      ...bank_calc_settings.menu,
    ],
  };

  const BankAdmin = {
    routes: [
      ...Bank.routes,
      ...payment_routes.routes,
      ...my_organization_routes.routes,
    ],
    menu: [
      ...Bank.menu,
      ...payment_routes.menu,
      ...my_organization_routes.menu,
    ],
  };

  const Agregator = {
    routes: [
      ...banned.routes,
      ...calc_routes.routes,
      ...calc_register_routes.routes,
      ...rating_routes.routes,
      ...agregator_calc_settings.routes,
    ],
    menu: [
      ...banned.menu,
      ...calc_routes.menu,
      ...calc_register_routes.menu,
      ...rating_routes.menu,
      ...agregator_calc_settings.menu,
    ],
  };

  const AgregatorAdmin = {
    routes: [
      ...Agregator.routes,
      ...payment_routes.routes,
      ...my_organization_routes.routes,
    ],
    menu: [
      ...Agregator.menu,
      ...payment_routes.menu,
      ...my_organization_routes.menu,
    ],
  };

  if (document.location.href.indexOf("https://lk.vmmm.ru/") != -1) {
    switch (role) {
      case "banned":
        return generateRoutes(banned);
      case "demo":
        return generateRoutes(demo);
      case "winners":
        return generateRoutes(winners);
      case "rating":
        return generateRoutes(rating);
      case "calcAndRaiting":
        return generateRoutes(calcAndRaiting);
      case "ratingWinners":
        return generateRoutes(ratingWinners);
      case "calcRatingWinners":
        return generateRoutes(calcRatingWinners);
      case "users":
        return generateRoutes(users);
      case "manager":
        return generateRoutes(manager);
      case "admin":
        return generateRoutes(admin);
      case "adminChelkunov":
        return generateRoutes(adminChelkunov);
      case "bankir":
        return generateRoutes(bankir);
      case "adminService":
        return generateRoutes(adminService);
      case "usersService":
        return generateRoutes(usersService);
      case "managersService":
        return generateRoutes(managerService);
      case "bank":
        return generateRoutes(Bank);
      case "agregator":
        return generateRoutes(Agregator);
      case "bankAdmin":
        return generateRoutes(BankAdmin);
      case "agregatorAdmin":
        return generateRoutes(AgregatorAdmin);
      default:
        return generateRoutes(banned);
    }
  } else {
    switch (role) {
      case "banned":
        return generateRoutes(banned);
      case "demo":
        return generateRoutes(demo);
      case "winners":
        return generateRoutes(winners);
      case "rating":
        return generateRoutes(rating);
      case "calcAndRaiting":
        return generateRoutes(calcAndRaiting);
      case "ratingWinners":
        return generateRoutes(ratingWinners);
      case "calcRatingWinners":
        return generateRoutes(calcRatingWinners);
      case "users":
        return generateRoutes(usersTest);
      case "manager":
        return generateRoutes(managerTest);
      case "admin":
        return generateRoutes(adminTest);
      case "adminChelkunov":
        return generateRoutes(adminChelkunovTest);
      case "bankir":
        return generateRoutes(bankir);
      case "adminService":
        return generateRoutes(adminService);
      case "usersService":
        return generateRoutes(usersService);
      case "managersService":
        return generateRoutes(managerService);
      case "bank":
        return generateRoutes(Bank);
      case "agregator":
        return generateRoutes(Agregator);
      case "bankAdmin":
        return generateRoutes(BankAdmin);
      case "agregatorAdmin":
        return generateRoutes(AgregatorAdmin);
      default:
        return generateRoutes(banned);
    }
  }
};
